<template>
  <div class="coach-management-container">
    <el-card>
      <div slot="header" class="card-header">
        <h3>教练管理</h3>
        <div class="header-actions">
          <!--          <el-button-->
          <!--              icon="el-icon-refresh"-->
          <!--              circle-->
          <!--              @click="handleRefresh"-->
          <!--              :loading="loading"-->
          <!--              title="刷新"-->
          <!--          ></el-button>-->
        </div>
      </div>

      <div class="toolbar">
        <div class="button-group">
          <el-button type="primary" @click="handleAdd" class="add-btn">新增教练</el-button>
          <el-button
              icon="el-icon-refresh"
              @click="handleRefresh"
              :loading="loading"
              class="refresh-btn"
          >刷新</el-button>
        </div>
      </div>

      <!-- 桌面端表格视图 -->
      <el-table :data="coaches" v-loading="loading" v-if="!isMobile">
        <el-table-column prop="user_id" label="用户ID" width="120">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.user_id && scope.row.user_id !== 0">
              {{ scope.row.user_id }}
            </el-tag>
            <el-tag v-else type="info">未关联</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="coachNumber" label="教练编号" width="120"></el-table-column>
        <el-table-column prop="realName" label="姓名" width="120"></el-table-column>
        <el-table-column prop="phone" label="手机号" width="150"></el-table-column>
        <el-table-column prop="level" label="等级" width="100">
          <template slot-scope="scope">
            <el-tag :type="getLevelType(scope.row.level)">
              {{ getLevelText(scope.row.level) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="teachYears" label="教龄" width="80">
          <template slot-scope="scope">
            {{ scope.row.teachYears }}年
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 'available' ? 'success' : 'info'">
              {{ scope.row.status === 'available' ? '在岗' : '休假' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" @click="handleViewSchedule(scope.row)">排班</el-button>
            <el-button type="text" @click="handleViewStudents(scope.row)">学员</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 移动端卡片视图 -->
      <div v-if="isMobile" class="mobile-coach-list" v-loading="loading">
        <div v-for="coach in coaches" :key="coach.coachId" class="coach-card">
          <el-card shadow="hover">
            <div class="card-header">
              <div class="coach-name-status">
                <h4>{{ coach.realName }}</h4>
                <el-tag :type="coach.status === 'available' ? 'success' : 'info'" size="mini">
                  {{ coach.status === 'available' ? '在岗' : '休假' }}
                </el-tag>
              </div>
              <div class="coach-number">{{ coach.coachNumber }}</div>
            </div>

            <div class="card-content">
              <div class="info-row">
                <span class="label">用户ID:</span>
                <span v-if="coach.user_id && coach.user_id !== 0" class="value">{{ coach.user_id }}</span>
                <el-tag v-else type="info" size="mini">未关联</el-tag>
              </div>

              <div class="info-row">
                <span class="label">手机号:</span>
                <span class="value">{{ coach.phone }}</span>
              </div>

              <div class="info-row">
                <span class="label">等级:</span>
                <el-tag :type="getLevelType(coach.level)" size="mini">
                  {{ getLevelText(coach.level) }}
                </el-tag>
              </div>

              <div class="info-row">
                <span class="label">教龄:</span>
                <span class="value">{{ coach.teachYears }}年</span>
              </div>
            </div>

            <div class="card-actions">
              <el-button type="text" size="small" @click="handleEdit(coach)">编辑</el-button>
              <el-button type="text" size="small" @click="handleViewSchedule(coach)">排班</el-button>
              <el-button type="text" size="small" @click="handleViewStudents(coach)">学员</el-button>
            </div>
          </el-card>
        </div>
      </div>

      <!-- 空状态提示 -->
      <div v-if="coaches.length === 0 && !loading" class="empty-state">
        <el-empty description="暂无教练数据">
          <el-button type="primary" @click="handleAdd">新增教练</el-button>
          <el-button @click="handleRefresh">刷新</el-button>
        </el-empty>
      </div>
    </el-card>

    <!-- 新增/编辑教练对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" :fullscreen="isMobile">
      <el-form :model="coachForm" ref="coachForm" :rules="rules" label-width="100px">
        <el-form-item label="用户ID" v-if="isEdit">
          <el-input v-model="coachForm.user_id" disabled></el-input>
          <div class="form-tip">用户ID为系统自动生成，不可修改</div>
        </el-form-item>

        <el-form-item label="教练编号" v-if="isEdit">
          <el-input v-model="coachForm.coachNumber" disabled></el-input>
          <div class="form-tip">教练编号为系统自动生成，不可修改</div>
        </el-form-item>

        <el-form-item label="用户名" prop="username" v-if="!isEdit">
          <el-input v-model="coachForm.username" placeholder="请输入用户名"></el-input>
        </el-form-item>

        <el-form-item label="密码" prop="password" v-if="!isEdit">
          <el-input
              v-model="coachForm.password"
              type="password"
              placeholder="请输入密码"
              show-password
          ></el-input>
        </el-form-item>

        <el-form-item label="姓名" prop="realName">
          <el-input v-model="coachForm.realName" placeholder="请输入真实姓名"></el-input>
        </el-form-item>

        <el-form-item label="手机号" prop="phone">
          <el-input v-model="coachForm.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>

        <el-form-item label="教练等级" prop="level">
          <el-select v-model="coachForm.level" placeholder="请选择等级">
            <el-option label="初级" value="primary"></el-option>
            <el-option label="中级" value="intermediate"></el-option>
            <el-option label="高级" value="senior"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="教龄" prop="teachYears">
          <el-input-number
              v-model="coachForm.teachYears"
              :min="0"
              :max="50"
              controls-position="right"
          ></el-input-number>
          <span class="unit-text">年</span>
        </el-form-item>

        <el-form-item label="专长" prop="specialty">
          <el-input
              v-model="coachForm.specialty"
              placeholder="如：科目二教学、科目三路训"
          ></el-input>
        </el-form-item>

        <el-form-item label="简介" prop="introduction">
          <el-input
              v-model="coachForm.introduction"
              type="textarea"
              :rows="3"
              placeholder="请输入教练简介"
              maxlength="500"
              show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitting">
          {{ submitting ? '提交中...' : '确定' }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { coachAPI } from '@/services/api'

export default {
  name: 'CoachManagement',
  data() {
    return {
      loading: false,
      submitting: false,
      coaches: [],
      dialogVisible: false,
      isEdit: false,
      isMobile: false,
      messagePosition: 'top-right',
      coachForm: {
        coachId: null,
        username: '',
        password: '',
        user_id: 0,
        coachNumber: '',
        realName: '',
        phone: '',
        level: 'primary',
        teachYears: 0,
        specialty: '',
        introduction: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 20, message: '用户名长度在 3 到 20 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
        ],
        realName: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 10, message: '姓名长度在 2 到 10 个字符', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
        ],
        level: [
          { required: true, message: '请选择教练等级', trigger: 'change' }
        ],
        teachYears: [
          { type: 'number', min: 0, max: 50, message: '教龄范围在 0 到 50 年', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    dialogTitle() {
      return this.isEdit ? '编辑教练信息' : '新增教练'
    }
  },
  async mounted() {
    this.checkIsMobile()
    window.addEventListener('resize', this.checkIsMobile)

    await this.loadCoaches()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkIsMobile)
  },
  methods: {
    checkIsMobile() {
      const width = window.innerWidth
      this.isMobile = width <= 768
      if (width <= 480) {
        this.messagePosition = 'top'
      } else if (width <= 768) {
        this.messagePosition = 'top'
      } else {
        this.messagePosition = 'top-right'
      }
    },

    showMessage(options) {
      const config = {
        duration: 3000,
        showClose: true,
        ...options
      }

      if (this.isMobile) {
        config.position = 'top'
        config.duration = 2000
      } else {
        config.position = this.messagePosition
      }

      this.$message(config)
    },

    async loadCoaches() {
      this.loading = true
      try {
        const response = await coachAPI.getAllCoaches()
        console.log('API响应数据:', response)

        if (response && response.data) {
          this.coaches = response.data.map(coach => {
            const userId = coach.userId || coach.user_id || coach.userID || null

            return {
              ...coach,
              user_id: userId,
              coachId: coach.coachId || coach.id,
              coachNumber: coach.coachNumber || coach.coach_number || `JL${String(coach.coachId || coach.id).padStart(3, '0')}`,
              realName: coach.realName || coach.real_name || coach.name || '未知',
              phone: coach.phone || '未填写',
              level: coach.level || 'primary',
              teachYears: coach.teachYears || coach.teach_years || 0,
              rating: coach.rating || 0,
              totalStudents: coach.totalStudents || coach.total_students || 0,
              status: coach.status || 'available'
            }
          })
        }
      } catch (error) {
        console.error('加载教练列表失败:', error)
        this.showMessage({
          message: '加载教练列表失败，请稍后重试',
          type: 'error'
        })
        this.useMockData()
      } finally {
        this.loading = false
      }
    },

    async handleRefresh() {
      await this.loadCoaches()
      this.showMessage({
        message: '教练列表已刷新',
        type: 'success'
      })
    },

    handleAdd() {
      this.isEdit = false
      this.coachForm = {
        coachId: null,
        username: '',
        password: '',
        user_id: 0,
        coachNumber: '',
        realName: '',
        phone: '',
        level: 'primary',
        teachYears: 0,
        specialty: '',
        introduction: ''
      }
      this.dialogVisible = true

      this.$nextTick(() => {
        if (this.$refs.coachForm) {
          this.$refs.coachForm.clearValidate()
        }
      })
    },

    handleEdit(coach) {
      this.isEdit = true

      const userId = coach.userId || coach.user_id || null

      this.coachForm = {
        ...coach,
        coachId: coach.coachId || coach.id,
        user_id: userId,
        coachNumber: coach.coachNumber || coach.coach_number || '',
        username: coach.username || '',
        password: ''
      }

      console.log('编辑教练数据:', this.coachForm)
      this.dialogVisible = true
    },

    async handleSubmit() {
      this.$refs.coachForm.validate(async (valid) => {
        if (valid) {
          this.submitting = true
          try {
            if (this.isEdit) {
              if (!this.coachForm.coachId) {
                this.showMessage({
                  message: '教练ID不能为空',
                  type: 'error'
                })
                this.submitting = false
                return
              }

              if (!this.coachForm.coachNumber) {
                this.showMessage({
                  message: '教练编号不能为空',
                  type: 'error'
                })
                this.submitting = false
                return
              }

              const updateData = {
                coachId: this.coachForm.coachId,
                coachNumber: this.coachForm.coachNumber,
                realName: this.coachForm.realName,
                phone: this.coachForm.phone,
                level: this.coachForm.level,
                teachYears: this.coachForm.teachYears,
                specialty: this.coachForm.specialty,
                introduction: this.coachForm.introduction
              }

              if (this.coachForm.user_id && this.coachForm.user_id !== 0) {
                updateData.user_id = this.coachForm.user_id
              }

              console.log('提交更新数据:', updateData)
              await coachAPI.updateCoach(updateData)
              this.showMessage({
                message: '教练信息更新成功',
                type: 'success'
              })
            } else {
              const createData = {
                username: this.coachForm.username,
                password: this.coachForm.password,
                realName: this.coachForm.realName,
                phone: this.coachForm.phone,
                coachLevel: this.coachForm.level,
                teachYears: this.coachForm.teachYears,
                specialty: this.coachForm.specialty,
                introduction: this.coachForm.introduction
              }

              console.log('提交创建数据:', createData)
              await coachAPI.addCoachByAdmin(createData)
              this.showMessage({
                message: '教练创建成功',
                type: 'success'
              })
            }

            this.dialogVisible = false
            await this.loadCoaches()
          } catch (error) {
            console.error('操作失败:', error)
            const errorMessage = error.response?.data?.message || error.message || '操作失败'
            this.showMessage({
              message: errorMessage,
              type: 'error'
            })
          } finally {
            this.submitting = false
          }
        } else {
          this.showMessage({
            message: '请完善表单信息',
            type: 'warning'
          })
          return false
        }
      })
    },

    handleViewSchedule() {
      this.showMessage({
        message: '管理员无法直接操作教练排班，请通知教练自行在教练端设置',
        type: 'warning'
      })
    },

    handleViewStudents(coach) {
      this.showMessage({
        message: '请在学员管理页面查看该教练的学员信息',
        type: 'info'
      })
      this.$router.push({
        path: '/dashboard/user-management',
        query: {coachId: coach.coachId || coach.id}
      })
    },

    getLevelType(level) {
      const types = {
        'primary': 'info',
        'intermediate': 'success',
        'senior': 'warning'
      }
      return types[level] || 'info'
    },

    getLevelText(level) {
      const texts = {
        'primary': '初级',
        'intermediate': '中级',
        'senior': '高级'
      }
      return texts[level] || level
    },

    useMockData() {
      this.coaches = [
        {
          coachId: 1,
          user_id: 1001,
          coachNumber: 'JL001',
          realName: '张三',
          phone: '13800138001',
          level: 'senior',
          teachYears: 8,
          status: 'available'
        },
        {
          coachId: 2,
          user_id: 1002,
          coachNumber: 'JL002',
          realName: '李四',
          phone: '13800138002',
          level: 'intermediate',
          teachYears: 5,
          status: 'available'
        }
      ]
    }
  }
}
</script>

<style scoped>
.coach-management-container {
  padding: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
}

.header-actions {
  display: flex;
  align-items: center;
}

.toolbar {
  margin-bottom: 20px;
  display: flex;
  gap: 10px;
  align-items: center;
}

.mobile-coach-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.coach-card {
  width: 100%;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.coach-name-status {
  display: flex;
  align-items: center;
  gap: 8px;
}

.coach-name-status h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.coach-number {
  color: #909399;
  font-size: 14px;
}

.card-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 16px;
}

.info-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.info-row .label {
  color: #606266;
  font-size: 14px;
  min-width: 60px;
}

.info-row .value {
  color: #303133;
  font-size: 14px;
  text-align: right;
}

.rating-container {
  display: flex;
  align-items: center;
}

.card-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.form-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

.unit-text {
  margin-left: 8px;
  color: #606266;
}

.empty-state {
  padding: 40px 0;
  text-align: center;
}

@media (max-width: 768px) {
  .coach-management-container {
    padding: 10px;
  }

  .toolbar {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .toolbar .el-button {
    align-self: flex-start;
    margin-bottom: 10px;
  }

  .el-table {
    font-size: 12px;
  }

  .el-table .el-table__header-wrapper,
  .el-table .el-table__body-wrapper {
    overflow-x: auto;
  }

  .el-table th,
  .el-table td {
    padding: 8px 4px;
    white-space: nowrap;
  }

  .coach-card .el-card {
    border-radius: 8px;
  }

  .coach-name-status h4 {
    font-size: 15px;
  }

  .info-row {
    padding: 4px 0;
  }

  .info-row .label,
  .info-row .value {
    font-size: 13px;
  }

  .card-actions .el-button {
    font-size: 13px;
    padding: 4px 6px;
  }

  .el-dialog {
    width: 95% !important;
    margin: 5% auto !important;
  }

  .el-dialog__body {
    padding: 15px;
  }

  .el-form-item__label {
    width: 80px !important;
  }

  .el-form-item__content {
    margin-left: 80px !important;
  }

  .card-header {
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
  }

  .header-actions {
    align-self: flex-end;
  }
}

@media (max-width: 480px) {
  .el-table {
    font-size: 11px;
  }

  .el-button--text {
    padding: 2px 4px;
    font-size: 11px;
  }

  .el-tag {
    font-size: 10px;
    padding: 0 6px;
    height: 22px;
    line-height: 22px;
  }

  .coach-name-status h4 {
    font-size: 14px;
  }

  .info-row .label,
  .info-row .value {
    font-size: 12px;
  }

  .card-actions .el-button {
    font-size: 12px;
  }
}
</style>
